import { Natures } from "consts";
import { isArray } from "utils";

/**
 *
 * @param natures {string[]}
 * @return {{adEngageEnabled: boolean, complianceFirstEnabled: boolean, creEnabled: boolean,
 * pollByEnabled: boolean, reportingEnabled: boolean, expandableComplianceEnabled: boolean,
 * resultsDisabled: boolean, horizontalOptionsEnabled: boolean, gamTargetingEnabled: boolean,
 * backButtonEnabled: boolean, backgroundImageEnabled: boolean, bulkResponseDeleteEnabled: boolean,
 * testContentRecAtEndEnabled: boolean, testQuestionDynamicNextEnabled: boolean,
 * testNoAutoAdvanceEnabled: boolean, testShareModalEnabled: boolean}}
 */
const evalNatures = (natures = []) => {
  const naturesSet = new Set(isArray(natures) ? natures : []);

  const adEngageEnabled = naturesSet.has(Natures.RootbeerEnabled);
  const complianceFirstEnabled = naturesSet.has(Natures.ComplianceFirst);
  const creEnabled = naturesSet.has(Natures.ContentRecommendationEngineEnabled);
  const pollByEnabled = naturesSet.has(Natures.ShowPollByCS);
  const reportingEnabled = naturesSet.has(Natures.QuestionReporting);
  const resultsDisabled = naturesSet.has(Natures.ResultsDisabled);
  const expandableComplianceEnabled = naturesSet.has(Natures.ExpandableCompliance);
  const horizontalOptionsEnabled = naturesSet.has(Natures.HorizontalOptions);
  const gamTargetingEnabled = naturesSet.has(Natures.GAMTargeting);
  const backButtonEnabled = naturesSet.has(Natures.BackButtonEnabled);
  const backgroundImageEnabled = naturesSet.has(Natures.BackgroundImgEnabled);
  const bulkResponseDeleteEnabled = naturesSet.has(Natures.BulkResponseDeleteEnabled);

  //TEST Natures
  //TODO: For now we have 2 natures for cre. Eventually after some prod testing, we may want to bring it to only one,
  // that may have an extra position attribute to identify where to put the cre list
  const testContentRecAtEndEnabled = naturesSet.has(Natures.ContentRecommendationEngineEndEnabled);
  const testQuestionDynamicNextEnabled = naturesSet.has(Natures.TestQuestionDynamicNext);
  const testNoAutoAdvanceEnabled = naturesSet.has(Natures.TestNoAutoAdvance);
  const testShareModalEnabled = naturesSet.has(Natures.TestShareModal);

  return {
    adEngageEnabled,
    complianceFirstEnabled,
    creEnabled,
    pollByEnabled,
    reportingEnabled,
    expandableComplianceEnabled,
    resultsDisabled,
    horizontalOptionsEnabled,
    gamTargetingEnabled,
    backButtonEnabled,
    backgroundImageEnabled,
    bulkResponseDeleteEnabled,

    //TEST Natures
    testContentRecAtEndEnabled,
    testQuestionDynamicNextEnabled,
    testNoAutoAdvanceEnabled,
    testShareModalEnabled,
  };
};

export default evalNatures;
